/* unplugin-vue-components disabled */import { render } from "./AreaSetIndex.vue?vue&type=template&id=e651e08e"
import script from "./AreaSetIndex.vue?vue&type=script&lang=js"
export * from "./AreaSetIndex.vue?vue&type=script&lang=js"

import "./AreaSetIndex.vue?vue&type=style&index=0&id=e651e08e&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__